import type { User } from "@/types/user.type";
import { create } from "zustand";
import { persist } from "zustand/middleware";

interface AuthStore {
  token: string | null;
  refreshToken: string | null;
  user: User | null;
  login: (token: string, refreshToken: string) => void;
  setUser: (user: User) => void;
  logout: () => void;
}

export const useAuthStore = create<AuthStore>()(
  persist(
    (set) => ({
      token: null,
      refreshToken: null,
      user: null,
      login: (token: string, refreshToken: string) =>
        set(() => ({
          token,
          refreshToken,
        })),
      setUser: (user: User) =>
        set(() => ({
          user,
        })),
      logout: () => {
        set(() => ({
          token: null,
          refreshToken: null,
          user: null,
        }));
      },
    }),
    {
      name: "auth-store",
      partialize: (state) => ({
        token: state.token,
        refreshToken: state.refreshToken,
      }),
    },
  ),
);
